export default "__VITE_ASSET__B478LJ18__"